import { render, staticRenderFns } from "./PanelTotal.vue?vue&type=template&id=08615ffe&scoped=true"
import script from "./PanelTotal.vue?vue&type=script&lang=js"
export * from "./PanelTotal.vue?vue&type=script&lang=js"
import style0 from "./PanelTotal.vue?vue&type=style&index=0&id=08615ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08615ffe",
  null
  
)

export default component.exports